import Attachments from '../attachments/store/index'
import Emails from '../emails/store/index'
import FollowUps from '../follow_ups/store/index'
import Quotations from '../quotations/store/index'
import Tasks from '../tasks/store/index'

export default {
    Attachments,
    Emails,
    FollowUps,
    Quotations,
    Tasks
}



// WEBPACK FOOTER //
// ./src/modules/deals/components/show/store/modules.js